"use strict";

var _classCallCheck = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _require = require("../attributes.js"),
    setAnExistingAttributeValue = _require.setAnExistingAttributeValue;

var NodeImpl = require("../nodes/Node-impl.js").implementation;

var _require2 = require("../node-type.js"),
    ATTRIBUTE_NODE = _require2.ATTRIBUTE_NODE;

exports.implementation =
/*#__PURE__*/
function (_NodeImpl) {
  _inherits(AttrImpl, _NodeImpl);

  function AttrImpl(globalObject, args, privateData) {
    var _this;

    _classCallCheck(this, AttrImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AttrImpl).call(this, globalObject, args, privateData));
    _this._namespace = privateData.namespace !== undefined ? privateData.namespace : null;
    _this._namespacePrefix = privateData.namespacePrefix !== undefined ? privateData.namespacePrefix : null;
    _this._localName = privateData.localName;
    _this._value = privateData.value !== undefined ? privateData.value : "";
    _this._element = privateData.element !== undefined ? privateData.element : null;
    _this.nodeType = ATTRIBUTE_NODE;
    _this.specified = true;
    return _this;
  }

  _createClass(AttrImpl, [{
    key: "namespaceURI",
    get: function get() {
      return this._namespace;
    }
  }, {
    key: "prefix",
    get: function get() {
      return this._namespacePrefix;
    }
  }, {
    key: "localName",
    get: function get() {
      return this._localName;
    }
  }, {
    key: "name",
    get: function get() {
      return this._qualifiedName;
    }
  }, {
    key: "nodeName",
    get: function get() {
      return this._qualifiedName;
    }
  }, {
    key: "value",
    get: function get() {
      return this._value;
    },
    set: function set(value) {
      setAnExistingAttributeValue(this, value);
    }
  }, {
    key: "ownerElement",
    get: function get() {
      return this._element;
    }
  }, {
    key: "_qualifiedName",
    get: function get() {
      // https://dom.spec.whatwg.org/#concept-attribute-qualified-name
      if (this._namespacePrefix === null) {
        return this._localName;
      }

      return this._namespacePrefix + ":" + this._localName;
    }
  }]);

  return AttrImpl;
}(NodeImpl);